export var getOptions = function (modules, lng) { return ({
    ns: [],
    backend: {
        modules: modules,
    },
    parseMissingKeyHandler: function (key) {
        return "#_" + key;
    },
    fallbackLng: "en",
    partialBundledLanguages: true,
    returnEmptyString: false,
    appendNamespaceToMissingKey: true,
    lng: lng
}); };
